import { createContext } from 'react'

const bidDepositContext = createContext()

export default bidDepositContext
